import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { getSectors } from '../lib/api'
import type { SectorItem } from '../lib/types'
import RiskDot from '../components/RiskDot'

const W: Record<string, number> = { true_demand: 0.30, hard_supply: 0.35, low_attention: 0.15, value_capture: 0.12, clear_catalyst: 0.08 }

export default function Detail() {
  const { id } = useParams()
  const [item, setItem] = useState<SectorItem | null>(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setLoading(true)
    getSectors().then(d => setItem(d.items.find(s => s.id === id) || null)).finally(() => setLoading(false))
  }, [id])
  if (loading) return <div className="text-muted py-12 text-center">加载中...</div>
  if (!item) return <div className="text-muted py-12 text-center">未找到赛道 <Link to="/" className="text-blue underline ml-2">返回</Link></div>
  const factors = [
    { key: 'true_demand', label: '真需求', value: item.true_demand, note: item.demand_note },
    { key: 'hard_supply', label: '硬供给', value: item.hard_supply, note: item.supply_note },
    { key: 'low_attention', label: '低关注', value: item.low_attention, note: item.attention_note },
    { key: 'value_capture', label: '价值捕获', value: item.value_capture, note: item.capture_note },
    { key: 'clear_catalyst', label: '催化剂', value: item.clear_catalyst, note: item.catalyst_note }
  ]
  return (
    <div>
      <Link to="/" className="text-muted text-sm hover:text-white">← 返回赛道列表</Link>
      <div className="mt-3 bg-card border border-border rounded-lg p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <h1 className="text-white text-2xl font-bold">{item.name}</h1>
            <div className="text-muted text-sm mt-1">{item.sector} · {item.ticker} · {item.market}</div>
            {item.chain_position && <div className="text-blue text-xs mt-1.5">{item.chain_position}</div>}
          </div>
          <div className="text-right">
            <div className="text-teal text-4xl font-bold">{item.composite_score}</div>
            <div className="text-muted text-xs mt-1">综合分 · <RiskDot level={item.risk_level} /></div>
          </div>
        </div>
        {item.description && <p className="text-muted text-sm mt-4 leading-relaxed">{item.description}</p>}
      </div>
      <h2 className="text-white text-lg font-semibold mt-6 mb-3">五因子评分</h2>
      <div className="space-y-3">
        {factors.map(f => (
          <div key={f.key} className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-center justify-between mb-1.5">
              <div className="flex items-center gap-2">
                <span className="text-white font-medium text-sm">{f.label}</span>
                <span className="text-muted text-xs">权重 {(W[f.key]! * 100).toFixed(0)}%</span>
              </div>
              <span className="text-teal font-semibold">{f.value}</span>
            </div>
            <div className="w-full h-2 bg-border rounded overflow-hidden mb-2">
              <div className="bg-teal h-full transition-all" style={{ width: `${f.value}%` }} />
            </div>
            {f.note && <p className="text-muted text-xs leading-relaxed">{f.note}</p>}
          </div>
        ))}
      </div>
    </div>
  )
}
